import * as actionTypes from '../actionsTypes'
import axios from '../../../http-config'
import swal from 'sweetalert'

export const fetchUlbDataStart = () => {
    return({
        type  : actionTypes.FETCH_ULB_DATA_START,
        loading: false
    })
}

export const fetchUlbDataSuccess = (response) => {
    return ({
        type    : actionTypes.FETCH_ULB_DATA_SUCCESS,
        payload : response.data.ulbs,
        totalCount : response.totalCount,
        loading:true
    })
}

export const fetchUlbDataFail = (error) => {
    return({
        type   : actionTypes.FETCH_ULB_DATA_FAIL,
        error  : error,
        loading:false
    })
}

export const fetchUlbData = (payload) => {

    const token = payload.token
    let url ;
    if(payload.searchQuery != ""&&payload.searchQuery != undefined){
        url = `ulb?name=${payload.searchQuery}&sortColumnName=${payload.sortName}&sortColumnType=${payload.sortValue}`
    }
 
    else{
        url = payload.limit !==undefined && payload.page !== undefined || payload.filter !== undefined?  payload.filter !== undefined ? `ulb?tfULBFilter=true` :`/ulb?sortColumnName=${payload.sortName}&sortColumnType=${payload.sortValue}&statedashboardValue=${!!payload.filterValue&&payload.filterValue !== ""? payload.filterValue:''}&isDisableULB=${!!payload.status&&payload.status != ""? payload.status:''}&typeId=${!!payload.filterTypesValue&&payload.filterTypesValue != ""? payload.filterTypesValue:''}`: '/ulb/?dropdown=true'
    }
    return (dispatch) => {
        dispatch(fetchUlbDataStart())
        axios({
            method  : 'get',
            url     :url,
            headers : {'Authorization': `Bearer ${token}`}
        })
        .then((response) => {
            dispatch(fetchUlbDataSuccess(response.data))
        })
        .catch((err) => {
            dispatch(fetchUlbDataFail(err))
        })
    }
}

export const addUlbData = (payload,SubmitProp, t)=>{
    let token=SubmitProp.token
    return (dispatch)=>{
        dispatch(fetchUlbDataStart())

        let url = '/ulb/';
        axios.post(url, payload,{headers:{
            "Authorization":`Bearer ${token}`
        }})
        .then((response) => {
            dispatch(fetchUlbData(payload));
            const fetchedResponse = response.data.success;
            if(fetchedResponse === true){
                fetchedResponse && swal({
                    title: `${t("ulbAdd")}`,
                    icon: "success",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                // props.history.push('/')
                dispatch(fetchUlbData({token:token, page:1, limit:10, sortName:'', sortValue:'',} ))
                // dispatch(fetchUlbData({token:token, page:1, limit:10, sortName:'', sortValue:'', searchQuery:'', filterTypesValue:'', filterTypesValue:'', status:''} ))
            }
                
        }, 
        (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})    
            dispatch(fetchUlbData({token:token, page:1, limit:10, sortName:'', sortValue:'',} ))       
        }).catch(error => {
            dispatch(fetchUlbDataFail(error))           
        })
        
    }
}
export const editUlbData = (payload, token, t) => {
    
    return dispatch => {
        dispatch(fetchUlbDataStart());
        let url = '/ulb/';
        axios.put(url, payload,{headers:{
            "Authorization":`Bearer ${token}`
        }})
        .then(response => {
            // dispatch(fetchUlbData(payload));
            const fetchedResponse = response.data.success;
            if(fetchedResponse ===true){
                fetchedResponse && swal({
                    title: `${t("ulbEdit")}`,
                    icon: "success",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                //   props.history.push('/')
                dispatch(fetchUlbData({token:token, page:1, limit:10, sortName:'', sortValue:'',} ))
            }
             
        }, (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})      
            dispatch(fetchUlbData({token:token, page:1, limit:10, sortName:'', sortValue:'',} ))    
        })
        .catch(err => {
            dispatch(fetchUlbDataFail(err))
        })
    }
}

export const deleteUlbData = (payload, token, t) => {

    return (dispatch) => {
        dispatch(fetchUlbDataStart())
        const url =  '/ulb/'
        axios.delete(url , { data : payload, headers : {   "Authorization":`Bearer ${token}`} })
        .then((response) => {
            const payload = {
                token :token
            }
            dispatch(fetchUlbData(payload))
            swal({
                title: `${t("ulbDeleteErr5")}`,
                icon: "success",
            })
            
        }, 
        (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]}) 
            dispatch(fetchUlbData({token:token, page:1, limit:10, sortName:'', sortValue:'',} )) 
        })
    }
}
export const SelectULbs =(payload, props)=>{
    return (dispatch)=>{
        dispatch(fetchUlbDataStart())

        let url = '/ulb/state_dashboard';
        axios.put(url, payload,{headers:{
            "Authorization":`Bearer ${payload.token}`
        }})
        .then((response) => {
            dispatch(fetchUlbData(payload));
            const fetchedResponse = response.data.success;
             if(response.data.data[0].StatedashboardValue === false){
                swal({
                    title: "ULB Removed",
                    icon: "success",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                props.history.push('/')
            }
             if(response.data.data[0].StatedashboardValue === true){
                swal({
                    title: "ULB Selected",
                    icon: "success",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                props.history.push('/')
            }
                
        }, 
        (err) => {
            if(!!err&&err.response.data.error[0]["message"]){
                swal({icon : "error" , title : err.response.data.error[0]["message"]})  
            }
                   
        }).catch(error => {
            dispatch(fetchUlbDataFail(error))           
        })
        
    }
}


export const searchULBName=(payload, t)=>{
    return dispatch =>{
        dispatch(fetchUlbDataStart());
        const url =`ulb?name=${payload.searchQuery}`
        axios.get(url,{headers:{
            "Authorization":`Bearer ${payload.token}`
        }} ).then(response=>{
            response && response.data && response.data.data.ulbs &&
            response.data.data.ulbs && 
            response.data.data.ulbs.length == 0 && 
            swal(`${t("ulbRecordErr")}`, {
                icon: "warning",
              });
            dispatch(fetchUlbDataSuccess(response.data));
        }).catch(err=>{
            dispatch(fetchUlbDataFail(err));
        })
    }
}
export const configuration =(payload, data, props)=>{
   return (dispatch)=>{
       dispatch(fetchUlbDataStart())

       let url =`ulb/configuration`
       axios.post(url, payload,{headers:{
           "Authorization":`Bearer ${data.token}`
       }})
       .then((response) => {
           dispatch(fetchUlbData(data));
           const fetchedResponse = response.data.success;
           if(fetchedResponse === true){
               fetchedResponse && swal({
                   title: "Configuration Added ",
                   icon: "success",
                   buttons: {
                       confirm: 'Ok'
                   }
                 })
               props.history.push('/')
           }
               
       }, 
       (err) => {
           swal({icon : "error" , title : err.response.data.error[0]["message"]})           
       }).catch(error => {
           dispatch(fetchUlbDataFail(error))           
       })
       
   }
}